<template>
    <CardDropdownSm :item="itemData">
        <template #icon>
            <ParagraphIcon class="flex-shrink-0 h-5 ct-fg-4" />
        </template>
        <template #extra>
            <FormToggleSm
                v-if="cookie.consentTypes"
                :modelValue="!getTypes('hide', item)"
                @update:modelValue="toggleType(item)"
            />
        </template>
    </CardDropdownSm>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { markRaw } from "vue";
import { PencilSquareIcon, InvisibleIcon, VisibleIcon, ParagraphIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { FormToggleSm } from "@easy/ui/forms";

export default {
    props: {
        item: String,
    },
    emits: ["edit", "delete", "duplicate", "toggleEnabled"],
    components: {
        CardDropdownSm,
        FormToggleSm,
        ParagraphIcon,
    },
    computed: {
        ...mapState("cookie", ["cookie", "consentTypes"]),
        ...mapGetters("cookie", ["defaultTypes"]),
        itemData() {
            return {
                title: this.getTypes("name", this.item),
                icon: markRaw(ParagraphIcon),
                actions: [
                    {
                        label: this.$t("shared.edit"),
                        icon: markRaw(PencilSquareIcon),
                        handler: () => {
                            this.$emit("edit");
                        },
                    },
                    {
                        label: !this.getTypes("hide", this.item)
                            ? this.$t("shared.hide")
                            : this.$t("shared.show"),
                        icon: !this.getTypes("hide", this.item)
                            ? markRaw(InvisibleIcon)
                            : markRaw(VisibleIcon),
                        handler: () => {
                            this.toggleType(this.item);
                        },
                    },
                ],
            };
        },
    },
    methods: {
        getTypes(prop, type) {
            return (
                (this.cookie.consentTypes[type] && this.cookie.consentTypes[type][prop]) ||
                this.defaultTypes[type][prop]
            );
        },
        toggleType(type) {
            if (!this.cookie.consentTypes[type]) this.cookie.consentTypes[type] = {};
            this.cookie.consentTypes[type].hide = !this.cookie.consentTypes[type].hide;
        },
    },
};
</script>
